import React, { ReactNode } from 'react';

import { UIFeatherIcon } from '@futrli/ui-components';

import { OutputFrequency } from './output-frequency';
import { OutputOnDayMonthly } from './output-on-day-monthly';
import { OutputOnDayWeekly } from './output-on-day-weekly';
import { OutputOnMonth } from './output-on-month';
import { RepeatingPattern } from '../../../types';

import styles from '../formula.scss';

export interface FormulaMethodTopBarProps {
  formulaFrequencyOnDay: string;
  formulaFrequencyOnMonth: string;
  handleFormulaFrequencyOnDayChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleFormulaFrequencyOnMonthChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleHelpClick: () => void;
  handleOutputFrequencyChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  hideFormulaControls?: boolean;
  outputFrequency: RepeatingPattern | null;
  PredictionHeader: React.FunctionComponent<{ children: ReactNode }>;
}

export const FormulaMethodTopBar = ({
  formulaFrequencyOnDay,
  formulaFrequencyOnMonth,
  handleFormulaFrequencyOnDayChange,
  handleFormulaFrequencyOnMonthChange,
  handleHelpClick,
  handleOutputFrequencyChange,
  hideFormulaControls,
  outputFrequency,
  PredictionHeader
}: FormulaMethodTopBarProps) => {
  return (
    <PredictionHeader>
      {!hideFormulaControls && (
        <>
          <OutputFrequency onChange={handleOutputFrequencyChange} value={outputFrequency} />
          {outputFrequency === RepeatingPattern.weekly && (
            <OutputOnDayWeekly onChange={handleFormulaFrequencyOnDayChange} value={formulaFrequencyOnDay} />
          )}
          {outputFrequency === RepeatingPattern.monthly && (
            <OutputOnDayMonthly onChange={handleFormulaFrequencyOnDayChange} value={formulaFrequencyOnDay} />
          )}
          {outputFrequency === RepeatingPattern.annually && (
            <>
              <OutputOnDayMonthly onChange={handleFormulaFrequencyOnDayChange} value={formulaFrequencyOnDay} />
              <OutputOnMonth onChange={handleFormulaFrequencyOnMonthChange} value={formulaFrequencyOnMonth} />
            </>
          )}
          <div className={styles.helpIcon} onClick={handleHelpClick}>
            <UIFeatherIcon iconName="help-circle" />
          </div>
        </>
      )}
    </PredictionHeader>
  );
};
